import Immutable from 'immutable';
import { CHANGE_FOLDER_PARTITIONING_FAILED, CHANGE_FOLDER_PARTITIONING_SUCCEEDED, CHANGE_FOLDER_PARTITIONING_ATTEMPTED } from '../actions/ActionTypes';
import { RequestStatus } from '../Constants';
const defaultState = Immutable.Map({
  status: RequestStatus.UNINITIALIZED
});
export default function Partitioning(state = defaultState, action) {
  const {
    type,
    status
  } = action;
  switch (type) {
    case CHANGE_FOLDER_PARTITIONING_ATTEMPTED:
    case CHANGE_FOLDER_PARTITIONING_SUCCEEDED:
    case CHANGE_FOLDER_PARTITIONING_FAILED:
      return state.merge({
        status
      });
    default:
      return state;
  }
}